import { Typography, Grid, IconButton, Popover } from "@material-ui/core";
import { useState, useEffect } from "react";
import Camera, { FACING_MODES } from "react-html5-camera-photo";
import "react-html5-camera-photo/build/css/index.css";
import logo from "../assets/stoqqyLogoWhite.png";
import animation from "../assets/loadAnimation.gif";
import { useSelector, useDispatch } from "react-redux";
import { setCamera } from "../redux/camera";
import { Close } from "@material-ui/icons";
import axios from "axios";
import { url } from "../constants";
import { CircularProgress } from "@material-ui/core";

const getSearchFromImage = async (uri) => {
  try {
    const response = await axios.post(`${url}searchImage`, {
      Image: uri,
    });
    return response?.data;
  } catch (error) {
    console.log(error);
  }
};

export default function LogoImage() {
  const [uri, setUri] = useState("");
  const camera = useSelector((state) => state.camera.value);
  const dispatch = useDispatch();
  const [load, setLoad] = useState(false);
  const [wait, setWait] = useState(false);
  const [noLogo, setNoLogo] = useState(false);
  const [unrelatedLogo, setUnrelatedLogo] = useState(false);

  useEffect(async () => {
    if (uri !== "") {
      setLoad(true);
      setWait(true);
      if (uri != "") {
        const suggestions = await getSearchFromImage(uri);
        if (suggestions.records === "No logo") {
          setNoLogo(true);
          setTimeout(() => {
            setNoLogo(false);
            setWait(false);
          }, 2000);
        } else if (
          suggestions.records === " logo it not related to a company"
        ) {
          setUnrelatedLogo(true);
          setTimeout(() => {
            setUnrelatedLogo(false);
            setWait(false);
          }, 2000);
        } else {
          setUri("");
          dispatch(setCamera({ isOpen: false, suggestions: suggestions }));
          setWait(false);
        }
      }
      setLoad(false);
    }
  }, [uri]);

  return (
    <>
      {camera.isOpen ? (
        <Popover
          open={true}
          PaperProps={{
            style: {
              backgroundColor: "#380c0c",
              padding: "15px",
              position: "absolute",
              inset: "0px 0px 0px 0px",
            },
          }}
          marginThreshold={0}
        >
          <Grid container>
            <Grid item xs={6}>
              <img
                src={logo}
                alt="logo"
                width={"100px"}
                style={{ margin: "8px 0 0px 0" }}
              />
            </Grid>

            <Grid
              item
              xs={6}
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              <IconButton
                size="small"
                onClick={() => {
                  dispatch(setCamera({ ...camera, isOpen: false }));
                }}
              >
                <Close fontSize="large" style={{ color: "#f8f8f8" }} />
              </IconButton>
            </Grid>
          </Grid>
          {load || wait ? (
            <>
              <Typography
                style={{
                  textAlign: "center",
                  fontSize: "24px",
                  fontWeight: "bold",
                  paddingBottom: "10px",
                  margin: "39px 2px 25px 6px",
                  fontfamily: "Overpass",
                  color: "#f8f8f8",
                }}
              >
                Wait for results...
              </Typography>
              <Grid style={{ width: "100%" }}>
                <img src={uri} width="100%" style={{ marginBottom: "24px" }} />
                {load ? (
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    {/* <CircularProgress style={{ color: "#808080" }} /> */}
                    <img src={animation}></img>
                  </div>
                ) : noLogo ? (
                  <Typography
                    style={{
                      textAlign: "center",
                      fontSize: "18px",
                      paddingBottom: "10px",
                      fontfamily: "Overpass",
                      color: "#f8f8f8",
                    }}
                  >
                    There is no logo in the picture
                  </Typography>
                ) : unrelatedLogo ? (
                  <Typography
                    style={{
                      textAlign: "center",
                      fontSize: "18px",
                      paddingBottom: "10px",
                      fontfamily: "Overpass",
                      color: "#f8f8f8",
                    }}
                  >
                    The logo is not related to a company.
                  </Typography>
                ) : null}
              </Grid>
            </>
          ) : (
            <>
              <Typography
                style={{
                  textAlign: "center",
                  fontSize: "24px",
                  fontWeight: "bold",
                  paddingBottom: "10px",
                  margin: "39px 2px 15px 6px",
                  fontfamily: "Overpass",
                  fontSize: "24px",
                  color: "#f8f8f8",
                }}
              >
                Take picture of a logo!
              </Typography>
              <Grid style={{ width: "100%" }}>
                <Camera
                  isImageMirror={false}
                  idealFacingMode={FACING_MODES.ENVIRONMENT}
                  idealResolution={{ height: 303, width: 290 }}
                  onTakePhoto={(dataUri) => {
                    // dispatch(setCamera({ ...camera, isOpen: false }));
                    setUri(dataUri);
                  }}
                />
              </Grid>
            </>
          )}
        </Popover>
      ) : null}
    </>
  );
}
